/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import styled, { css } from 'styled-components';

import Button from '@components/Forms/Button';
import { getEnv } from '@config';
import classes from './Success.module.scss';

const { publicPath } = getEnv();

const HelperText = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Body-2-w400']}
    text-align: center;
    margin-top: -19px;
    margin-bottom: 32px;
    color: ${theme.colors.gray700};
  `
);

const ChildrenContainer = styled.div`
  margin-top: -19px;
`;

const SubText = styled.div`
  width: 20.625rem;
  height: 2.438rem;
  font-family: Roboto;
  font-size: 0.875rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  margin: 1rem 0px 3.875rem 0px;
  color: ${({ theme }) => theme.colors.gray700};
`;

const Success = ({
  imgStyle,
  h2Style,
  buttonStyle,
  gridProds,
  helperText,
  firstLine,
  secondLine,
  thirdLine,
  buttonText,
  handleClick,
  helperId = 'helper-text-id',
  type = 'success',
  tag,
  htmlIdButton = 'unidentified-id',
  transactionsFlag,
  children,
  maxWidth = '100%',
  shouldShowButton = true,
  shouldWrapChildren = true,
}) => {
  const HelperStyle = {
    paddingTop: helperText === true ? '23px' : '0px',
  };
  const image = type === 'success' ? 'check' : 'ils_error';

  return (
    <Grid item xs={12}>
      <Box maxWidth={maxWidth} margin="auto">
        <Grid item xs={12} {...gridProds}>
          <img
            src={`${publicPath}/${image}.svg`}
            width="114px"
            height="114px"
            alt="logo de la empresa"
            id={type === 'success' ? 'withdraw-money-funds-out-success' : 'withdraw-money-funds-out-error'}
            style={{ ...imgStyle }}
          />
        </Grid>
        <Grid item xs={12} {...gridProds}>
          <h2 data-testid="sucess_first-line" style={{ ...h2Style, marginTop: '25px' }}>
            {firstLine}
          </h2>
        </Grid>
        <Grid item xs={12} {...gridProds}>
          <h2
            data-testid="second-line"
            style={{ ...h2Style, marginBottom: thirdLine ? '0px' : '35px' }}
          >
            {secondLine}
          </h2>
        </Grid>
        {thirdLine && (
          <Grid item xs={12} {...gridProds}>
            <SubText data-testid="third-line">{thirdLine}</SubText>
          </Grid>
        )}
        {helperText && (
          <Grid item xs={12} {...gridProds}>
            <HelperText id={helperId}>{helperText}</HelperText>
          </Grid>
        )}
        {children && (
          <Grid item xs={12} {...gridProds}>
            {shouldWrapChildren ? (
              <Grid item xs={12} sm={8} md={4}>
                <ChildrenContainer>{children}</ChildrenContainer>
              </Grid>
            ) : (
              <ChildrenContainer>{children}</ChildrenContainer>
            )}
          </Grid>
        )}
        {shouldShowButton && (
          <Grid item xs={12} {...gridProds} style={HelperStyle}>
            <Button
              className={transactionsFlag ? '' : classes.button}
              style={buttonStyle}
              tag={tag}
              onClick={handleClick}
              id={htmlIdButton}
            >
              {buttonText}
            </Button>
          </Grid>
        )}
      </Box>
    </Grid>
  );
};

export default Success;
